// import { openWindow } from '..';
import type {RouteLocationRaw, Router} from 'vue-router';
import {useRouter} from 'vue-router';

import {PageEnum} from '/@/enums/pageEnum';
import {isString} from '/@/utils/is';
import {unref} from 'vue';
import {REDIRECT_NAME} from '/@/router/constant';

export type RouteLocationRawEx = Omit<RouteLocationRaw, 'path'> & { path: PageEnum };

function handleError(e: Error) {
    console.error(e);
}

// page switch
export function useGo(_router?: Router) {
    let router;
    if (!_router) {
        router = useRouter();
    }
    const {push, replace} = _router || router;

    function go(opt: PageEnum | RouteLocationRawEx | string = PageEnum.BASE_HOME, isReplace = false) {
        if (!opt) {
            return;
        }
        if (isString(opt)) {
            isReplace ? replace(opt).catch(handleError) : push(opt).catch(handleError);
        } else {
            const o = opt as RouteLocationRaw;
            isReplace ? replace(o).catch(handleError) : push(o).catch(handleError);
        }
    }

    return go;
}

/**
 * @description: redo current page
 */
export const useRedo = (_router?: Router) => {
    const {push, currentRoute} = _router || useRouter();
    const {query, params = {}, name, fullPath} = unref(currentRoute.value);

    function redo(): Promise<boolean> {
        return new Promise((resolve) => {
            if (name === REDIRECT_NAME) {
                resolve(false);
                return;
            }
            if (name && Object.keys(params).length > 0) {
                params['_redirect_type'] = 'name';
                params['path'] = String(name);
            } else {
                params['_redirect_type'] = 'path';
                params['path'] = fullPath;
            }
            push({name: REDIRECT_NAME, params, query}).then(() => resolve(true));
        });
    }

    return redo;
};

export function userOpenWindow(_router) {
    let url =
        window.location.protocol +
        '//' +
        window.location.hostname +
        '/' +
        window.location.pathname.split('/')[1] +
        _router.toString();
    window.open(url, '_blank');
}

// 跳转工作台
export function getUrlToDsahboard(_router) {
    let url =
        window.location.protocol +
        '//' +
        window.location.hostname +
        _router.toString();
    window.location.href = url
}

// 跳转企业或社保
export function getUrlToProject(_router, _pro) {//('/socialSecurity/archives','/qiye')

    let url =
        window.location.protocol +
        '//' +
        window.location.hostname + _pro.toString() + _router.toString();
    window.location.href = url    //当前tab跳转
}


export function navigateTo(url: string, target: string = '_blank') {
    if (url.startsWith('http://') || url.startsWith('https://')) {
        window.open(url, target);
    } else {
        const origin = window.location.origin;
        url = `${origin}${import.meta.env.VITE_PUBLIC_PATH}${url.startsWith('/') ? '' : '/'}${url}`;
        window.open(url, target);
    }
}